module.exports = __webpack_public_path__ + "images/dingtalk/init-member-A-e46a10ce133d2dfeb6833b74ee9dfe45.png";